import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { Button } from '@repo/design-system/components/ds/button';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectMapName, selectTitleName } from '@repo/store/maps/slices/mapData';
import type React from 'react';
import { WandExperienceModal } from '../components/wand-experience-modal';
interface EmbedLimitModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
}
export const EmbedLimitModal: React.FC<EmbedLimitModalProps> = t0 => {
  const $ = _c(16);
  const {
    isOpen,
    onOpenChange
  } = t0;
  const gameTitle = useAppSelector(selectTitleName);
  const mapName = useAppSelector(selectMapName);
  const hostType = useHostType();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["game_map"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useT(t1);
  const analytics = useAnalytics();
  let t2;
  if ($[1] !== analytics || $[2] !== gameTitle || $[3] !== hostType || $[4] !== mapName || $[5] !== onOpenChange) {
    t2 = () => {
      onOpenChange();
      analytics.event("embed_limit_prompt_open_in_wemod_click", {
        mapName: mapName || "",
        titleName: gameTitle || "",
        platform: hostType
      });
      const url = new URL(window.location.href);
      url.searchParams.delete("isMiniMapMode");
      url.searchParams.delete("hostMode");
      url.searchParams.delete("rpcType");
      window.open(url.toString(), "_blank", "noopener,noreferrer");
    };
    $[1] = analytics;
    $[2] = gameTitle;
    $[3] = hostType;
    $[4] = mapName;
    $[5] = onOpenChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleOpenInWandClick = t2;
  let t3;
  if ($[7] !== t) {
    t3 = t(_temp);
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== handleOpenInWandClick || $[10] !== t3) {
    t4 = <Button onClick={handleOpenInWandClick} color="white" size="lg" fullWidth={true}>{t3}</Button>;
    $[9] = handleOpenInWandClick;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isOpen || $[13] !== onOpenChange || $[14] !== t4) {
    t5 = <WandExperienceModal isOpen={isOpen} onOpenChange={onOpenChange} cta={t4} />;
    $[12] = isOpen;
    $[13] = onOpenChange;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp($) {
  return $.game_map_embed_limit_prompt.open_in_wand;
}